import { render, staticRenderFns } from "./yajin.vue?vue&type=template&id=463a49fe&scoped=true&"
import script from "./yajin.vue?vue&type=script&lang=js&"
export * from "./yajin.vue?vue&type=script&lang=js&"
import style0 from "./yajin.vue?vue&type=style&index=0&id=463a49fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a49fe",
  null
  
)

export default component.exports